import { type Resolver, schemaSystemMails } from 'cpool-schemas';
import type { z } from 'zod';

type Arguments = {
    position?: number;
};

export const schemaSystemVariableResolver_GetSystemMailTypes = schemaSystemMails.nullable();

export type SchemaSystemVariableResolver_GetSystemMailTypes = z.infer<
    typeof schemaSystemVariableResolver_GetSystemMailTypes
>;

export type SystemVariableResolver_GetSystemMailTypes = Resolver<
    Arguments,
    SchemaSystemVariableResolver_GetSystemMailTypes
>;
